import type React from 'react';
import { EmptyState } from '@heroui-pro/react';
import { Icon } from '@iconify/react';

type ProductPanelNoticeProps = {
    /** Iconify icon name. */
    icon: string;
    /** Translated by the caller. */
    title: string;
};

/** The product panel's in-place notice (the catalog failed, nothing matches): an icon over one line. */
export const ProductPanelNotice: React.FC<ProductPanelNoticeProps> = ({
    icon,
    title,
}) => (
    <EmptyState>
        <EmptyState.Header>
            <EmptyState.Media variant="icon">
                <Icon icon={icon} />
            </EmptyState.Media>
            <EmptyState.Title>{title}</EmptyState.Title>
        </EmptyState.Header>
    </EmptyState>
);
